<template>
  <Link
    :href="route(`${routePrefix}.${resourceType}.adjust`, getParams())"
    class="px-1 sort-link d-inline-block text-muted"
  >
    <i class="bi bi-2x" :class="getSortDirectionIcon(column, sort)" style="font-size: 1.5rem"></i>
  </Link>
</template>

<script>
import { Link } from '@inertiajs/vue3';

export default {
  components: {
    Link,
  },
  props: {
    column: { type: String, default: '' },
    resourceType: { type: String, default: '' },
    sort: { type: String, default: '' },
    params: { type: Object, default: () => {} },
  },
  emits: ['update:params'],
  setup(props) {
    const getSortDirectionIcon = (column, sort) => {
      let iconClass = ' bi-sort-';
      iconClass += sort === column ? 'down-alt' : 'down';
      iconClass += sort === column || sort === '-' + column ? ' active' : '';
      return iconClass;
    };

    const getParams = () => {
      if (props.params.sort === props.sort) {
        let params = props.params;
        params.sort = '-' + props.sort;

        return params;
      }

      return props.params;
    };

    return {
      getParams,
      getSortDirectionIcon,
    };
  },
};
</script>
